"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAttributeBasedFilterToSQLQuery = void 0;
const convertSimpleOptionTypeToSQL = (value) => {
    if (typeof value === 'object') {
        return value.toISOString().replace('T', ' ').replace('Z', '');
    }
    else if (value === '$$_SELF_$$') {
        // TODO: add implementation
        throw new Error(`$$_SELF_$$ is not implemented yet`);
    }
    else if (value === '$$_USER_$$') {
        throw new Error(`$$_USER_$$ is not supported`);
    }
    else {
        return `'${String(value)}'`;
    }
};
const convertSimpleOptionArrayTypeToSQL = (values) => {
    if (values === '$$_GROUPS_$$') {
        throw new Error(`$$_GROUPS_$$ is not implemented`);
    }
    else if (values === '$$_ROLES_$$') {
        throw new Error(`$$_ROLES_$$ should not get here - handle earlier`);
    }
    else if (Array.isArray(values)) {
        return values.map(value => convertSimpleOptionTypeToSQL(value));
    }
};
const convertSimpleOptionToSQLQuery = (simpleOption, data, roles) => {
    if (simpleOption.operator === 'EQUAL') {
        return convertSimpleOptionTypeToSQL(data[simpleOption.key]) === convertSimpleOptionTypeToSQL(simpleOption.options);
    }
    if (simpleOption.operator === 'INCLUDE') {
        if (simpleOption.options === '$$_ROLES_$$') {
            if (roles) {
                return roles.includes(data[simpleOption.key]);
            }
            return data[simpleOption.key] || false;
        }
        return convertSimpleOptionArrayTypeToSQL(simpleOption.options).includes(convertSimpleOptionTypeToSQL(data[simpleOption.key]));
    }
    if (simpleOption.operator === 'NULL') {
        return data[simpleOption.key] === null || data[simpleOption.key] === undefined;
    }
    if (simpleOption.operator === 'NOTNULL') {
        return data[simpleOption.key] !== null && data[simpleOption.key] !== undefined;
    }
};
const convertAttributeBasedFilterToSQLQuery = (attributeBasedAccessRule, data, roles) => {
    const queries = attributeBasedAccessRule.condition
        .map(condition => {
        if (condition.type === 'GroupFilter') {
            if (!condition.condition.length) {
                return '';
            }
            return (0, exports.convertAttributeBasedFilterToSQLQuery)(condition, data, roles);
        }
        return convertSimpleOptionToSQLQuery(condition, data, roles);
    })
        .filter(q => q || q === false);
    let result = queries.length
        ? attributeBasedAccessRule.conjunction === 'AND'
            ? true
            : false
        : true;
    for (const q of queries) {
        if (attributeBasedAccessRule.conjunction === 'AND') {
            if (q === false) {
                return false;
            }
            if (q === true) {
                continue;
            }
            if (typeof q === 'string') {
                if (Array.isArray(result)) {
                    result = result.map(r => r + '+' + q);
                }
                else {
                    result = [q];
                }
            }
            else {
                if (Array.isArray(result)) {
                    result = result.reduce((prev, curr) => {
                        return prev.concat(...q.map(item => curr + '+' + item));
                    }, []);
                }
                else {
                    result = q;
                }
            }
        }
        else {
            if (q === true) {
                return true;
            }
            if (q === false) {
                continue;
            }
            if (typeof q === 'string') {
                if (Array.isArray(result)) {
                    result.push(q);
                }
                else {
                    result = [q];
                }
            }
            else {
                if (Array.isArray(result)) {
                    result.push(...q);
                }
                else {
                    result = q;
                }
            }
        }
    }
    return result;
};
exports.convertAttributeBasedFilterToSQLQuery = convertAttributeBasedFilterToSQLQuery;
//# sourceMappingURL=processingHelper.js.map